/**
 * Created by Mark on 23/11/2016.
 */

import ENVIRONMENT_CONSTANTS from './environment.js'

export default {
    GET_SCREEN_MODULES: ENVIRONMENT_CONSTANTS.BASE_URL + '/screensController/getAllModuleIds',
    UPDATE_SCREEN_MODULES: 'UPDATE_SCREEN_MODULES',
    GET_VERBS:ENVIRONMENT_CONSTANTS.BASE_URL + '/verbTranslationController/getVerbCategories',
    GETMAP: ENVIRONMENT_CONSTANTS.BASE_URL + '/screensController/getContentMap',
}


// WEBPACK FOOTER //
// ./src/constants/screens.js